/**
 * Site Name Configuration
 * Auto-generated from: KEYWORD + NICHE + COUNTRY
 * Format: {keyword} {niche} {country}
 * This file is auto-generated - do not edit manually
 * 
 * Generated at: 2026-02-06T13:44:03.869Z
 */

// Site name auto-generated from keyword, niche, and country
export const SITE_NAME = 'treffen trans germany'

export default SITE_NAME
